
import { Component, Emit } from 'vue-property-decorator';
import OfferCreateForm from './create.vue';
import { Send } from '@/components/form-base';
import { pick } from 'lodash';

import reportUtils from '@/views/reports/report-utils';
import ApiServices from '@/services';

@Component
export default class Edit extends OfferCreateForm {

  reportUtils = reportUtils(this);

  get modalTitle(){
    return this.t('Edit Offer')
  }

    async load() {
      this.offer_id = this.offer_id || this.$store.getters.selectedItem.id;
      const offer:any = await this.offerApi.get(this.offer_id).then((data: any) => {
        data.payoutSum = data.payoutSum || 0;

      this.form = pick(data, [
        'name',
        'countryId',
        'tags',
        'url',
        'affiliateNetworkId',
        'clickIdParam',
        'currencyId',
        'payoutType',
        'payoutSum',
        'enableDailyCap',
        'dailyCapLimit',
        'dailyCapTimezone', 
        'status',
        'workspaceId',
        'created',
        'updated',
        'updatedBy',
      ]);

      this.form = {
        ...this.form,
        dailyCapFailoverOffer:{
          id:data.dailyCapFailoverOfferId,
          name:data.dailyCapFailoverOfferName
        }
      }
      
      return data;
    });

      if(offer.enableDailyCap) {
        await this.loadDailyCapOffers();
      }
    }

  loadData() {
    this.edit = true;
    this.offer_id = this.data.id;
    this.lastAffiliateNetworkId = null;

    this.$store.commit('loading', true);
    this.load()
      .then(() => this.getChangeAffiliatesPromise())
      .then(() => {
        this.show = true;
        this.oldHash = this.getCurrentHash();
      })
      .finally(() => this.$store.commit('loading', false));
  }

  @Send()
  submit() {
    this.$store.commit('loading', true);

    this.emptyUrlSend = !this.form.url;

    return this.offerApi.putUpdate(this.offer_id, this.processForm(this.form)).then(async (data: any) => {
      await ApiServices.getUserProfile();
      this.oldHash = this.getCurrentHash();
      const { id } = data;

      this.reportUtils.updateName('offers', id);

      this.bus.emit('refresh-report');
      this.bus.emit('toast-success', this.t('Offer has been changed'));

      this.data?.onEdit?.(data)

      const {enableDailyCap,name,dailyCapLimit} = this.form;
      this.$mixpanel?.track('offer_edit', {
        name,
        ...(enableDailyCap && {'daily_cap_limit': dailyCapLimit}),
      });
      this.close();
    })
    .finally(() => {
      this.$store.commit('loading', false);
    });
  }

}
